import script from "./DoublesGame.vue?vue&type=script&setup=true&lang=js"
export * from "./DoublesGame.vue?vue&type=script&setup=true&lang=js"

import "./DoublesGame.vue?vue&type=style&index=0&id=faf3b264&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faf3b264"]])

export default __exports__